import { render, staticRenderFns } from "./AcolhimentoAtividades.vue?vue&type=template&id=f7124bf6"
import script from "./AcolhimentoAtividades.vue?vue&type=script&lang=js"
export * from "./AcolhimentoAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports